export default __webpack_public_path__ + "static/media/product-raise-left.c284489d.png";